import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b8a5cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "image-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_4 = { class: "logo-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "scroll-btn" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Scroll Down", -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'BannerComponent',
  emits: ['scroll-to-section'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

function handleClick() {
  emit('scroll-to-section');
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, {
        src: require(`@/assets/home/banner-img.png`),
        alt: "Banner Image",
        class: "main-img"
      }, null, 8, ["src"]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: require(`@/assets/header/logo.png`),
          alt: "Logo"
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: require(`@/assets/home/scroll-down.png`),
          class: "scroll-icon",
          alt: "scroll image",
          onClick: handleClick
        }, null, 8, _hoisted_8),
        _hoisted_9
      ])
    ])
  ]))
}
}

})